export const pluralize = (number: number, forms: [string, string, string]) => {
  const n = Math.floor(number);
  return forms[
    n % 100 > 4 && n % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][Math.min(n % 10, 5)]
  ];
};
